import { render, staticRenderFns } from "./SuggestionButtons.vue?vue&type=template&id=18fe062c&"
import script from "./SuggestionButtons.vue?vue&type=script&lang=js&"
export * from "./SuggestionButtons.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionButtons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports